import React, { Component } from "react";
import { Route } from "react-router-dom";

import { history, routerPath } from "@config";

export class PrivateRouteNew extends Component {
  componentDidMount() {
    const user = sessionStorage.getItem("user");
    if (!user) {
      history.push(routerPath.login);
    }
  }

  render() {
    let Com = this.props.component;

    return <Route exact={this.props.exacts} render={props => <Com {...props} />} />;
  }
}
